module.exports = __webpack_public_path__ + "static/img/kf.1a8c6340.png";